import { withInstall } from '@ll-plus/utils'

import AvatarGroup from './src/avatar-group.vue'
import Avatar from './src/avatar.vue'

export const LlAvatar = withInstall(Avatar)
export const LlAvatarGroup = withInstall(AvatarGroup)

export * from './src/avatar'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlAvatar: typeof Avatar
    LlAvatarGroup: typeof AvatarGroup
  }
}
